//@flow
export function roundHoursMinutes({ m: minutes = 0, h: hours = 0 }: { m?: number, h?: number }) {
  const roundedMins = hours > 0 ? 0 : minutes;
  let roundedHrs;
  if (hours <= 0) {
    roundedHrs = hours;
  } else if (minutes > 45) {
    roundedHrs = hours + 1;
  } else if (minutes > 15) {
    roundedHrs = hours + 0.5;
  } else {
    roundedHrs = hours;
  }
  return { m: minutes, h: hours, rm: roundedMins, rh: roundedHrs };
}

export function secondsToRoundedHoursMinutes(cook_time_seconds: number) {
  const hours = Math.floor(cook_time_seconds / 3600);
  const minutes = Math.floor((cook_time_seconds % 3600) / 60);
  return roundHoursMinutes({ m: minutes, h: hours });
}
